<template>
  <div class="tab-content">
    <div v-if="count">
      <div class="serices-list">
        <ul style="list-style: decimal">
          <li
            v-for="(contractorService, index) in contractor_services"
            v-if="
              index == 0 ||
              contractorService.service_name !=
                contractor_services[index].service_name
            "
          >
            Added service {{ contractorService.service_name }} at
            {{ contractorService.log_created_date }}
          </li>
        </ul>
      </div>
      <hr />
      <h3>Appointments</h3>
      <div class="visits-list">
        <ul style="list-style: decimal">
          <li v-for="visits_log in visits_logs" v-html="visits_log"></li>
        </ul>
      </div>
    </div>
    <div v-else>
      <div class="inquiry-no-result">
        <br />
        <h3 class="font-bold"><span class="fa fa-ban"></span> No Job Requests Submitted
        </h3>
        <p class="font-14 w-80">
          There are no job requests for this booking yet.
          Job requests can be sent to fieldworkers either manually or automatically when bookings are created,
          depending on whether the automatic job assignment feature is enabled
          . These requests may be sent to one or more fieldworkers, and the job will be assigned to the first fieldworker who accepts it if automatic assignment is turned on. Once a fieldworker accepts the request, it will be tracked and displayed here.
          For more details, <a target="_blank" href="/settings/job-assignment-dispatch" >visit Job Assignment Help.</a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { getSingleTabData } from "@/modules/Booking/api/BookingViewTabs";
import moment from "moment-timezone";
import { EventBus } from "@/events/event-bus";

export default {
  name: "ServiceStatusTab",
  props: {
    itemType: {
      type: String,
      required: true,
    },
    itemId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      contractor_services: [],
      visits_logs: [],
      count: 0,
      dateTimeObj: null,
    };
  },
  computed: {},
  methods: {
    formatDate(notifyTime) {
      const dateFormat = this.convertToMomentFormat(
        this.dateTimeObj?.date_format
      );
      return moment(notifyTime * 1000)
        .tz(this.dateTimeObj.time_zone)
        .format(dateFormat);
    },
    convertToMomentFormat(format) {
      const mapping = {
        "EEEE, d MMMM y": "dddd, D MMMM YYYY",
        "d MMMM y": "D MMMM YYYY",
        "d MMM y": "D MMM YYYY",
        "dd/mm/yyyy": "DD/MM/YYYY",
        // Add any additional mappings as needed
      };
      return mapping[format] || "Format not recognized";
    },
    getSingleTabData() {
      let params = {
        type: "status-history",
        booking_id: this.itemId,
        fromVuejs: true,
      };
      getSingleTabData(params).then((response) => {
        this.dateTimeObj = response.data.dateTimeObj;
        this.contractor_services = response.data.contractor_services || [];
        this.visits_logs = response.data.visits_logs || [];
        this.count = response.data.count;
      });
    },
  },
  mounted() {
    this.getSingleTabData();
  },
};
</script>

<style scoped>
.tab-content {
  padding: 20px;
}

.font-14{
  font-size:14px
}
.w-80{
  width:80%;
  margin: auto;
}
</style>
